<template>
  <div>
    <v-switch v-model="enabled" label="appendIcon" dense hide-details @change="toggleAppendIcon" class="mb-2" />

    <DevContainerOfPanel
      v-if="enabled"
      :schema="{
        type: 'devContainerOfPanel',
        model: 'appendIcon',
        component: 'dev-simple-object-attr',
        styleClasses: 'col-12',
        title: 'append Icon'
      }"
      :model="{ appendIcon: model.appendIcon }"
    />
  </div>
</template>

<script>
import { abstractField } from 'vue-form-generator';

import eventBus from 'vue-option-events';
import * as HANDLERS from '@/helpers/types/handlers';

export default {
  mixins: [abstractField],

  components: {
    DevContainerOfPanel: () => import('@/components/dev/dev-container-of-panel')
  },

  data: () => ({
    enabled: false,
    appendIcon: {
      right: true,
      icon: 'access_time',
      attributesIcon: {
        color: 'primary',
        class: ''
      },
      tooltip: {
        text: 'Lorem Ipsum',
        tooltipColorClass: 'primary',
        trigger: 'click'
      }
    }
  }),

  mounted() {
    'appendIcon' in this.model && (this.enabled = true);
  },

  methods: {
    toggleAppendIcon(e) {
      if (e) this.model.appendIcon = this.appendIcon;

      if (!e) delete this.model.appendIcon;

      eventBus.$emit(HANDLERS.RELOAD_COMPONENT_DEV);
    }
  }
};
</script>
